export default "__VITE_ASSET__BOVuWbVi__"